import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, Stack, Typography } from '@mui/material';
import { isReplayConversation, listConversations, loadConversation } from './history';
import { surfaceLabel } from './LivySurfacePicker';
/**
 * Past conversations, rebuilt from the transcript tier. That tier has a short retention by design,
 * so history is deliberately recent rather than permanent, and says so.
 */
export function LivyHistory(_ref) {
  let open = _ref.open,
    onClose = _ref.onClose,
    onResume = _ref.onResume;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    busy = _useState4[0],
    setBusy = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(() => {
    if (!open) return;
    setError(null);
    listConversations().then(setItems).catch(e => setError(e.message));
  }, [open]);
  const resume = async (id, surface) => {
    setBusy(id);
    try {
      onResume(id, await loadConversation(id), surface);
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(null);
    }
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "sm"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      px: '18px',
      py: '14px',
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 15,
      fontWeight: 600
    }
  }, "Recent conversations"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary"
  }, "Transcripts are kept for 90 days")), /*#__PURE__*/React.createElement(Box, {
    sx: {
      maxHeight: 420,
      overflowY: 'auto',
      p: '10px'
    }
  }, error && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "error",
    sx: {
      p: '10px'
    }
  }, error), !items && !error && /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    sx: {
      py: '24px'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 20
  })), (items === null || items === void 0 ? void 0 : items.length) === 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      p: '10px'
    }
  }, "Nothing yet."), items === null || items === void 0 ? void 0 : items.map(c => /*#__PURE__*/React.createElement(Button, {
    key: c.conversationId,
    fullWidth: true,
    disabled: busy !== null,
    onClick: () => resume(c.conversationId, c.surface),
    sx: {
      justifyContent: 'space-between',
      textTransform: 'none',
      px: '12px',
      py: '10px',
      borderRadius: '8px',
      color: 'text.primary',
      '&:hover': {
        bgcolor: 'action.hover'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      fontSize: 13.5
    }
  }, surfaceLabel(c.surface), isReplayConversation(c.conversationId) ? ' · backtest' : ''), /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      fontSize: 12,
      color: 'text.secondary'
    }
  }, c.lastActivityAt ? new Date(c.lastActivityAt).toLocaleString() : '', busy === c.conversationId ? ' …' : '')))));
}